import { Form, FormGroup, Nav, NavItem, Panel, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 68vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 62vh;
        font-size: 12px;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 23px;
        // display: flex;
        // align-items: center;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    span.targeted > .dropdown {
        padding: 0px;
    }

    span.targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.active-targeted > .dropdown > .dropdown-toggle {
        background-color: transparent;
        color: yellow;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    span.category > .dropdown > .dropdown-toggle {
        background-color: transparent;
        // color: green;
        font-weight: 700;
        font-size: 16px;
        padding: 0px 10px 0px 10px;
        border: 0 none;
    }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }
        
    .ag-row.ag-row-focus {
        z-index: 1;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    display: flex;
    align-items: center;

    & > .control-label {
        margin-bottom: 0px;
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    // & > li {
    //     height: 52px;
    // }

    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .ms-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    & > div > .ms-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .ms-pills > li.li-divider {
        height: 50px;
        display: flex;
        align-items: center;
    }

    & > div > .ms-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        // margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid red;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

interface INavItemProps {
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: ${(p: INavItemProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    // }

    height: 50px;
    display: flex !important;
    align-items: center;
    text-align: center;

    & > a {
        // border-radius: 8px !important;
        // text-align: center;
        // border: 1px solid #337ab7;
        // min-height: 72px;
    }

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }
`;